module.exports = __webpack_public_path__ + "media/images/elionline/favicon-207b858710f9f52eb9dce2a1a5b8232d.ico";